import { render, staticRenderFns } from "./top-bar.vue?vue&type=template&id=a9e8c13c&scoped=true"
import script from "./top-bar.vue?vue&type=script&lang=js"
export * from "./top-bar.vue?vue&type=script&lang=js"
import style0 from "./top-bar.vue?vue&type=style&index=0&id=a9e8c13c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e8c13c",
  null
  
)

export default component.exports